import { Typography } from "@king-ict/eupisi-ui/components";
import { nameof, hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import StaticField from "../../components/StaticField";
import UploadButton from "../../components/UploadButton";
import { DocumentType } from "../../models/Document";
import { ProgramRequestTeacher } from "../../models/ProgramRequest"
import styles from "./ProgramRequestDetails.module.scss";


type ProgramRequestTeacherProps = {
    requestTeachers: ProgramRequestTeacher[],
    requestTeachersCorrections?: ProgramRequestTeacher[]
}

export default function ProgramRequestTeacherPanel ({ requestTeachers, requestTeachersCorrections} : ProgramRequestTeacherProps) : JSX.Element{
    const { t } = useTranslation();    
    return (
        <>
            <Row>
                <Col md={12} className={styles.rowTitleSpacing}>
                    <Typography variant="smallHeading" component="h3">
                        {t("request.teacherTitle")}                        
                    </Typography>
                </Col>
            </Row>
            {requestTeachers.map((teacher, teacherIndex) =>{ 
                const teacherCorrection = requestTeachersCorrections && requestTeachersCorrections.length > teacherIndex ? requestTeachersCorrections[teacherIndex] : undefined;
                return(               
                    <div className={styles.modulePanel}>
                        <Row>
                            <Col md={3}>
                                <StaticField
                                    label={t("request.teacherOIB")}                                
                                    value={teacher.oib}
                                    newValue={teacherCorrection?.oib}
                                    className={styles.changedFieldModule}
                                />
                            </Col>
                            <Col md={3}>
                                <StaticField
                                    label={t("request.teacherFirstName")}                                
                                    value={teacher.firstName}
                                    newValue={teacherCorrection?.firstName}
                                    className={styles.changedFieldModule}
                                />
                            </Col>
                            <Col md={3}>
                                <StaticField
                                    label={t("request.teacherLastName")}                                
                                    value={teacher.lastName}
                                    newValue={teacherCorrection?.lastName}
                                    className={styles.changedFieldModule}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} className={styles.hideUploadButton}>                                  
                                {teacher.diplomaDocument &&
                                    <UploadButton
                                        label={t("request.teacherDiplomaLabel")}                                    
                                        name={nameof<typeof teacher>("diplomaDocument")}                                    
                                        value={teacher.diplomaDocument}
                                        disabled={true}
                                        documentType={DocumentType.TeacherDiploma}
                                    /> ||
                                    <StaticField
                                        label={t("request.teacherDiplomaLabel")}                                    
                                        value={teacher.diplomaDocument?.fileName}
                                        className={styles.changedFieldModule}
                                    />
                                }
                            </Col>
                            <Col md={3} className={styles.hideUploadButton}>                                                            
                                {teacher.statement &&
                                    <UploadButton
                                        label={t("request.teacherStatementLabel")}                                    
                                        name={nameof<typeof teacher>("statement")}                                    
                                        value={teacher.statement}
                                        disabled={true}
                                        documentType={DocumentType.TeacherStatement}
                                    /> ||
                                    <StaticField
                                        label={t("request.teacherStatementLabel")}                                    
                                        value={teacher.statement?.fileName}
                                        className={styles.changedFieldModule}
                                    />
                                }
                            </Col>
                            <Col md={3} className={styles.hideUploadButton}>                                   
                                {teacher.additionalDocumentation &&   
                                    <UploadButton
                                        label={t("request.teacherDocumentationLabel")}                                    
                                        name={nameof<typeof teacher>("additionalDocumentation")}                                    
                                        value={teacher.additionalDocumentation}
                                        disabled={true}
                                        documentType={DocumentType.TeacherAdditional}
                                    /> ||
                                    <StaticField
                                        label={t("request.teacherDocumentationLabel")}                                                               
                                        value={teacher.additionalDocumentation?.fileName}
                                        className={styles.changedFieldModule}
                                    />
                                }
                            </Col>
                        </Row>                                    
                        {teacher.programRequestClassEnsambles && teacher.programRequestClassEnsambles.map((ensamble, ensambleIndex) => (
                            <Row>
                                <Col md={12} className={"d-flex"}>
                                    <StaticField
                                        className={styles.changedFieldModule}
                                        label={t("request.classEnsamble")}
                                        value={ensamble.ensamble}
                                        newValue={teacherCorrection?.programRequestClassEnsambles[ensambleIndex].ensamble}
                                    />      
                                </Col>
                            </Row>
                        )) || 
                            <StaticField
                                label={t("request.classEnsamble")}
                                value={"--"}
                                className={styles.changedFieldModule}                                
                            />  
                        }
                        {teacher.languages && teacher.languages.length > 0 &&
                        
                            <Row>
                                <Col md={12} className={styles.rowTitleSpacing}>
                                    <Typography variant="smallHeading" component="h3">
                                        {t("common.language")}
                                    </Typography>
                                </Col>
                            </Row>                            
                        }
                        {
                            teacher.languages?.map((teacherLanguage) => (
                                
                                <Row>
                                    <Col md={3}>
                                        <StaticField
                                            label={t("teacherLanguage.language")}   
                                            value={teacherLanguage.language?.name}
                                            className={styles.changedFieldModule}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <StaticField
                                            label={t("common.dateFrom")}   
                                            value={hrDate(teacherLanguage.dateFrom)}
                                            className={styles.changedFieldModule}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <StaticField
                                            label={t("common.dateTo")}
                                            value={teacherLanguage.dateTo ? hrDate(teacherLanguage.dateTo) : "-"}
                                            className={styles.changedFieldModule}
                                        />
                                    </Col>
                                    <Col md={3} className={styles.hideUploadButton}>
                                        {teacherLanguage.certificationDocument && 
                                            <UploadButton
                                                label={t("teacherLanguage.certificationDocument")}
                                                name={nameof<typeof teacherLanguage>("certificationDocument")}
                                                value={teacherLanguage.certificationDocument}
                                                disabled={true}
                                                documentType={DocumentType.TeacherLanguageCertification}
                                            />
                                            ||
                                            <StaticField
                                                label={t("teacherLanguage.certificationDocument")}                           
                                                value={teacherLanguage.certificationDocument?.fileName}
                                                className={styles.changedFieldModule}
                                            />
                                        }                                        
                                    </Col>
                                </Row>

                            ))                        
                        }                        
                    </div>
                    )
                })}
        </> 
    );

};